<template>
  <v-touch tag="g"
           v-if="pusher.role === 'functionPusherA'"
           @tap="tapMethod()"
           @press="pressMethod()"
           @pressup="pressupMethod()"
           @pan="pressupMethod()"
           @pancancel="pressupMethod()">
    <text class="pusherText pusherA" x="136" y="75" rotate="-30" text-anchor="middle" alignment-baseline="middle" style="pointer-events: none; user-select: none;">A</text>
    <polygon :id="pusher.id" class="pusher-button" fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" points="120.4103,77.2641 128.5933,72.5394 132.8454,79.9038 124.6623,84.6285"/>
    <path fill="whitesmoke" stroke="#808184" stroke-width="0.288" stroke-miterlimit="10" d="M120.4382,75.6116l3.5593-2.0551
			c0.4069-0.2349,0.9273-0.0955,1.1622,0.3114l4.8187,8.3458c0.2349,0.4068,0.0955,0.9271-0.3113,1.1619l0,0l-3.5593,2.0551
			c-0.4068,0.2349-0.9271,0.0955-1.162-0.3113l0,0l-4.8188-8.3459C119.8922,76.3667,120.0315,75.8465,120.4382,75.6116z"/>
  </v-touch>
  <v-touch tag="g"
           v-else-if="pusher.role === 'functionPusherB'"
           @tap="tapMethod()"
           @press="pressMethod()"
           @pressup="pressupMethod()"
           @pan="pressupMethod()"
           @pancancel="pressupMethod()">
    <text class="pusherText pusherB" x="135" y="146" rotate="30" text-anchor="middle" alignment-baseline="middle" style="pointer-events: none; user-select: none;">B</text>
    <polygon :id="pusher.id" class="pusher-button" fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" points="120.4103,142.7385 124.6622,135.3739 132.8454,140.0985 128.5935,147.463"/>
    <path fill="whitesmoke" stroke="#808184" stroke-width="0.288" stroke-miterlimit="10" d="M120.1269,143.2292l4.8187-8.346
			c0.2349-0.4068,0.7551-0.5462,1.1619-0.3113l3.5592,2.055c0.4068,0.2349,0.5462,0.7551,0.3113,1.1619l-4.8187,8.346
			c-0.2349,0.4068-0.7551,0.5462-1.1619,0.3113l-3.5592-2.055C120.0314,144.1563,119.892,143.6361,120.1269,143.2292z"/>
  </v-touch>
</template>

<script>
import { debounce } from 'lodash';

export default {
  name: 'sdPusher',
  props: ['pusherData', 'tutorialModeData', 'watchData', 'bus'],
  data() {
    return {
      pusherTimeout: undefined,
      pusherContinueEvent: false,
      debounceAnimatePusher: debounce(this.animatePusher, 100, { leading: true, maxWait: 0, trailing: true }),
    };
  },
  computed: {
    pusher() {
      if (this.pusherData) return this.pusherData;
    },
    tutorialMode() {
      if (this.tutorialModeData) return this.tutorialModeData;
    },
    wristwatch() {
      if (this.watchData) return this.watchData;
    },
    interpret() {
      if (this.interpretData) return this.interpretData;
    },
    tapMethod() {
      if (this.wristwatch && this.pusher) {
        return () => {
          this.interpretChrono(...this.pusher.clickParams);
          if (this.tutorialMode) {
            this.$emit('evaluate-component', this.wristwatch);
          }
        };
      }
      return () => {};
    },
    pressMethod() {
      // counterReset is the only method that lets us
      // speed up a pusher function
      if (this.wristwatch.counterReset.inProgress) {
        return () => {
          this.pusherTimeout = setTimeout(() => {
            this.pusherContinueEvent = true;
            const quick = setInterval(() => {
              this.tapMethod();
              if (!this.pusherContinueEvent) clearInterval(quick);
            }, 16);
          }, 0);
        };
      }
      return () => this.tapMethod();
    },
    pressupMethod() {
      return () => {
        if (this.tutorialMode) {
          this.$emit('evaluate-component', this.wristwatch);
        }
        this.pusherContinueEvent = false;
        clearTimeout(this.pusherTimeout);
      };
    },
  },
  methods: {
    interpretChrono(self) {
      // Check that crown is in correct position(s) for chronograph operation
      if (this.wristwatch.components.crown.value !== 2) {
        this.debounceAnimatePusher(self);
        if (self.role === 'functionPusherA') {
          /*
            PUSHER A **************************************************
            pusherA: [0 = untouched; 1 = pause; 2 = run; 3 = interval]
            */
          if (self.value === 0) {
            // Untouched; Start chronograph measurement
            self.value = 2;
            this.$emit('set-chrono-to-zero');
            this.wristwatch.chronoRunning = true;
            this.updateChrono(self.parent);
          } else if (self.value === 1) {
            // Paused; Resume chronograph measurement
            self.value = 2;
            this.wristwatch.chronoRunning = true;
            this.updateChrono(self.parent);
          } else if (self.value === 2) {
            // Running; Pause chronograph measurement
            self.value = 1;
            this.wristwatch.chronoRunning = false;
          }
        } else if (self.role === 'functionPusherB') {
          /*
            PUSHER B **************************************************
            pusherB: [0 = untouched; 1 = resume/run; 2 = interval]
             */
          if (this.wristwatch.components.pusherA.value === 1) {
            // Paused; Reset chronograph to zero
            self.value = 0;
            this.wristwatch.components.pusherA.value = 0;
            this.$emit('set-chrono-to-zero');
            this.wristwatch.chronoRunning = false;
            this.$emit('update-chrono-values', { modelId: self.parent, reset: true });
            this.fullTurnSecond();
            this.fullTurnChronoH();
            this.fullTurnChronoM();
          } else if (this.wristwatch.components.pusherA.value === 2) {
            // Running; Display interval/SPLIT time;
            // elapsed time continues updating
            this.wristwatch.chronoInterval = this.wristwatch.chronoNow;
            self.value = 2;
            this.wristwatch.components.pusherA.value = 3;
            this.wristwatch.chrono.interval = {
              milliseconds: this.wristwatch.chrono.milliseconds,
              seconds: this.wristwatch.chrono.seconds,
              minutes: this.wristwatch.chrono.minutes,
              hours: this.wristwatch.chrono.hours,
            };
          } else if (this.wristwatch.components.pusherA.value === 3 && self.value === 2) {
            // Interval is displayed; End interval/SPLIT;
            // Resume elapsed time display
            this.wristwatch.chronoInterval = false;
            self.value = 1;
            this.wristwatch.components.pusherA.value = 2;
          }
        }
        /*
          HANDS **************************************************
          Animate color to indicate pusher activity
           */
          this.$emit('debounce-handset-highlight', {componentSet: [this.wristwatch.components.second, this.wristwatch.components.chronoM, this.wristwatch.components.chronoH]})
        } else {
          // Chronograph is disabled.
          // Reset counters initiated
          this.debounceAnimatePusher(self, !this.wristwatch.counterReset.inProgress)
          this.resetCounters(self)
        }
      },
      updateChrono (modelId) {
        // If chronograph is running, update elapsed time every tenth-second
        if (this.wristwatch.chronoRunning) {
          // If interval is being displayed, use interval for display
          // AND continue updating elapsed time every tenth-second
          this.wristwatch.chronoInterval ? this.$emit('update-chrono-values', {modelId, reset: false, displayInterval: true}) : this.$emit('update-chrono-values', {modelId, reset: false})
          this.wristwatch.chronoTimeout = setTimeout(() => { this.updateChrono(modelId) }, 100)
        } else {
          clearTimeout(this.wristwatch.chronoTimeout)
          this.wristwatch.chronoTimeout = undefined
        }
      },
      animatePusher (self, both = false) {
        // TODO: Figure out why pushers aren't animating
        // const pushers = both === false ? [self] : [this.wristwatch.components.pusherA, this.wristwatch.components.pusherB]
        // pushers.forEach(pusher => {
        //   const pusherElem = pusher.element.select('.pusher-button')
        //   const y = pusher.role === 'functionPusherA' ? 1 : -1
        //   pusherElem.animate(90).dmove(-1.7321, y).after(() => pusherElem.animate(80).dmove(1.7321, -y))
        // })
      },
      fullTurnSecond () {
        this.wristwatch.components.second.element
          .animate((60 - this.wristwatch.chronoNow.seconds) * 16)
          .transform({
            rotation: (360 + (this.wristwatch.chrono.zero.seconds * 6)),
            cx: this.wristwatch.components.second.cx,
            cy: this.wristwatch.components.second.cy
          })
      },
      fullTurnChronoH () {
        this.wristwatch.components.chronoH.element
          .animate(this.wristwatch.id === 'a22' ? 12000 : this.wristwatch.chronoNow.milliseconds)
          .transform({
            rotation: this.wristwatch.id === 'a22'
              ? 360 + (((this.wristwatch.chrono.zero.hours % 12) / 12) * 360) + (this.wristwatch.chrono.zero.minutes / 24)
              : (360 + ((this.wristwatch.chrono.zero.milliseconds / 100) * 36)),
            cx: this.wristwatch.components.chronoH.cx,
            cy: this.wristwatch.components.chronoH.cy
          })
      },
      fullTurnChronoM () {
        this.wristwatch.components.chronoM.element
          .animate(this.wristwatch.id === 'a22' ? 12000 : (this.wristwatch.chronoNow.minutes % 30) * 33)
          .transform({
            rotation: this.wristwatch.id === 'a22'
              ? 8640 - (this.wristwatch.chrono.zero.minutes * 12) + (this.wristwatch.chrono.zero.seconds / 30)
              : (360 + (this.wristwatch.chrono.zero.minutes * 12) + (this.wristwatch.chrono.zero.seconds / 30)),
            cx: this.wristwatch.components.chronoM.cx,
            cy: this.wristwatch.components.chronoM.cy
          })
      },
      resetCounters (self) {
        // Function for resetting counters, set by set, to correct zero position
        if (this.wristwatch.counterReset && !this.wristwatch.counterReset.inProgress) {
          this.$emit('blink-circle', this.wristwatch.components.pusherA)
          this.$emit('blink-circle', this.wristwatch.components.pusherB)
          // Reset chronograph values to zero position
          this.$emit('set-chrono-to-zero')
          // Clear existing pusher events
          const pushers = [this.wristwatch.components.pusherA, this.wristwatch.components.pusherB]
          this.$emit('clear-events-from-components', {components: pushers})
          // Init pusher events for counter setting (done by Pusher component)
          // Chrono second should spin to zero position
          this.wristwatch.counterReset.inProgress = true
          this.wristwatch.counterReset.value = 1
          this.$emit('debounce-handset-highlight', {componentSet: [this.wristwatch.components.second, this.wristwatch.components.chronoM, this.wristwatch.components.chronoH], color: '#F2DA00'})
          this.fullTurnSecond()
          this.fullTurnChronoH()
          this.fullTurnChronoM()
        } else {
          // Reset counters is in progress
          // pusher A (push/hold): counter is incremented
          // pusher B: advances to next counter resetting
          let amount
          switch (this.wristwatch.counterReset.value) {
            case 1:
              // Adjust Chrono second counter
              // updated value needs be in range of 0 < x < component's modulus - 1 (e.g. this.wristwatch.chrono.zero.seconds + 1 % 60 === 60)
              amount = {seconds: this.wristwatch.chronoNow.seconds + 1 % 60 === 60 ? -59 : 1}
              if (self.role === 'functionPusherA') {
                this.$emit('debounce-handset-highlight', {componentSet: [this.wristwatch.components.second], color: '#F2DA00'})
                this.$emit('update-chrono-values', {modelId: this.wristwatch.id, reset: false, displayInterval: false, amount})
                this.wristwatch.chrono.zero.seconds = this.wristwatch.chronoNow.seconds
              } else {
                if (this.wristwatch.id === 'a22') {
                  this.$emit('debounce-handset-highlight', {componentSet: [this.wristwatch.components.chronoH, this.wristwatch.components.chronoM], color: '#F2DA00'})
                  this.wristwatch.counterReset.value = 2
                } else {
                  this.$emit('debounce-handset-highlight', {componentSet: [this.wristwatch.components.chronoH], color: '#F2DA00'})
                  this.wristwatch.counterReset.value = 3
                }
              }
              break
            case 2:
              // A-22: Adjust hour and minute counters
              amount = {minutes: 1}
              if (self.role === 'functionPusherA') {
                this.$emit('debounce-handset-highlight', {componentSet: [this.wristwatch.components.chronoH, this.wristwatch.components.chronoM], color: '#F2DA00'})
                this.$emit('update-chrono-values', {modelId: this.wristwatch.id, reset: false, displayInterval: false, amount})
                this.wristwatch.chrono.zero.minutes = this.wristwatch.chronoNow.minutes
                this.wristwatch.chrono.zero.hours = this.wristwatch.chronoNow.hours
              } else {
                this.$emit('debounce-handset-highlight', {componentSet: [this.wristwatch.components.second], color: '#F2DA00'})
                this.wristwatch.counterReset.value = 1
              }
              break
            case 3:
              // A-36: Adjust milliseconds/hour counter
              amount = {milliseconds: this.wristwatch.chronoNow.milliseconds + 100 % 1000 === 1000 ? -900 : 100}
              if (self.role === 'functionPusherA') {
                this.$emit('debounce-handset-highlight', {componentSet: [this.wristwatch.components.chronoH], color: '#F2DA00'})
                this.$emit('update-chrono-values', {modelId: this.wristwatch.id, reset: false, displayInterval: false, amount})
                this.wristwatch.chrono.zero.milliseconds = this.wristwatch.chronoNow.milliseconds
              } else {
                this.$emit('debounce-handset-highlight', {componentSet: [this.wristwatch.components.chronoM], color: '#F2DA00'})
                this.wristwatch.counterReset.value = 4
              }
              break
            case 4:
              // A-36: Adjust minute counter
              amount = {minutes: this.wristwatch.chronoNow.minutes + 1 % 30 === 30 ? -29 : 1}
              if (self.role === 'functionPusherA') {
                this.$emit('debounce-handset-highlight', {componentSet: [this.wristwatch.components.chronoM], color: '#F2DA00'})
                this.$emit('update-chrono-values', {modelId: this.wristwatch.id, reset: false, displayInterval: false, amount})
                this.wristwatch.chrono.zero.minutes = this.wristwatch.chronoNow.minutes
              } else {
                this.$emit('debounce-handset-highlight', {componentSet: [this.wristwatch.components.second], color: '#F2DA00'})
                this.wristwatch.counterReset.value = 1
              }
              break
          }
        }
      }
    },
    mounted () {
      this.$emit('initialize-component', {component: this.pusher, element: this.$el})
      if (this.pusher.role === 'functionPusherA') this.bus.$on('start-chrono', this.interpretChrono)
    }
  }
</script>

<style lang="scss" scoped>
  .pusherText {
    font: 300 0.75ch/1 futura-pt, 'futura-pt', sans-serif;
    text-anchor: middle;
    vertical-align: middle;
  }
  .display-only .pusherText {
    display: none;
  }
</style>
